exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-search-results-details > .content > .rows > .row > .column.cr-participants > .column-content {\n  padding: 0 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.component-search-results-details .rows .row .column.cr-participants > .column-content > div {\n  height: auto;\n}\n.component-search-results-details .rows .row .column.cr-participants .column-content .scrollable-panel .field-wrapper {\n  padding: 0;\n}\n", ""]);

// exports
